<template>
  <div class="mx-0">
    <v-img
      height="100vh"
      :src="$webp ? 'imagenes/personal.webp' : 'imagenes/personal.jpg'"
      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
    >
      <v-layout column align-center justify-center fill-height mx-12>
        <v-flex xs1 sm1 md1 lg1>
          <h1 class="font-weight-bold white--text text-center">
            Crédito Nómina
          </h1>
          <h3
            v-html="colorBannerText2"
            class="white--text text-center mt-2"
          ></h3>
        </v-flex>
      </v-layout>
    </v-img>
    <vc-requirements-personal />
    <vc-request-modal />
    <vc-politic-banner :image="`imagenes/logo.svg`"></vc-politic-banner>
    <vc-footer></vc-footer>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    dialog: false,
    colorBannerText2:
      "Aplica solo para reestructuras y financiamiento de polizas de seguro",
    colorBannerText:
      "Aplica solo para reestructuras y financiamiento de polizas de seguro",
  }),
};
</script>
<style scoped>
.animated {
  -webkit-animation: pulse 0.5s infinite alternate;
  animation: pulse 0.5s infinite alternate;
}
@-webkit-keyframes pulse {
  to {
    -webkit-transform: scale(1.05);
  }
}
@keyframes pulse {
  to {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
}
.bg-white {
  background-color: #ffffff !important;
}
.container {
  max-width: 2785px !important;
}
.bg-primary_dark {
  background: #8a172b !important;
}
</style>
